import slice from './reducer'
import emailLabelsSaga from './sagas'

export const {
  fetchRequest: fetchEmailLabelsRequest,
  fetchSuccess: fetchEmailLabelsSuccess,
  fetchError: fetchEmailLabelsError,
  fetchDetailsRequest: fetchEmailLabelDetailsRequest,
  fetchDetailsSuccess: fetchEmailLabelDetailsSuccess,
  createRequested: createEmailLabelRequested,
  createSuccess: createEmailLabelSuccess,
  createError: createEmailLabelError,
  updateRequested: updateEmailLabelRequested,
  updateSuccess: updateEmailLabelSuccess,
  updateError: updateEmailLabelError,
} = slice.actions

export default slice.reducer
export { emailLabelsSaga }
